import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/org/')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
